import { CATEGORIES, CATEGORY_GROUPS } from '@wingman/shared';
import { Compass, Coffee, Utensils, ShoppingBag, TreePine, Landmark, Dumbbell, Zap, Theater, Images, Binoculars, TrainFront, Film, BookOpen } from 'lucide-react';

const categoryIcons: Record<string, typeof Compass> = {
  restaurant: Utensils,
  cafe: Coffee,
  shop: ShoppingBag,
  park: TreePine,
  museum: Landmark,
  gym: Dumbbell,
  charging: Zap,
  theatre: Theater,
  gallery: Images,
  'historic-site': Landmark,
  viewpoint: Binoculars,
  'transit-station': TrainFront,
  cinema: Film,
  library: BookOpen,
};

interface CategoryFilterProps {
  activeCategory: string | null;
  onCategoryChange: (category: string | null) => void;
}

export default function CategoryFilter({ activeCategory, onCategoryChange }: CategoryFilterProps) {
  return (
    <div className="category-segments" role="group" aria-label="Place categories">
      <button
        type="button"
        className={`category-segment ${activeCategory === null ? 'is-active' : ''}`}
        onClick={() => onCategoryChange(null)}
        aria-pressed={activeCategory === null}
      >
        <Compass size={14} />
        ALL
      </button>
      {CATEGORY_GROUPS.map((group) => (
        <div key={group.label} className="category-segment-group">
          <span className="system-section-label">{group.label}</span>
          {group.slugs.map((slug) => {
            const cat = CATEGORIES.find((category) => category.slug === slug);
            if (!cat) return null;
            const Icon = categoryIcons[cat.slug] || Compass;
            return (
              <button
                type="button"
                key={cat.slug}
                className={`category-segment ${activeCategory === cat.slug ? 'is-active' : ''}`}
                onClick={() => onCategoryChange(activeCategory === cat.slug ? null : cat.slug)}
                aria-pressed={activeCategory === cat.slug}
              >
                <Icon size={14} />
                {cat.name}
              </button>
            );
          })}
        </div>
      ))}
    </div>
  );
}
